import Button from '../components/Button';
import { Inset } from '../components/Styles';

const Recovery = ({ setAppState }) => (
  <>
    { typeof navigator !== 'undefined'
      && (
      <Inset css={{ marginTop: '1rem' }}>
        <div css={{ paddingTop: '2rem' }}>
          Something unexpected happened. Sorry! We will try
          to fix this issue in an app update ASAP.
        </div>
        <Button
          to="/"
          onClick={() => {
            setAppState({ recovery: false });
          }}
          variant="primary"
        >
          OK
        </Button>
      </Inset>
      )}
  </>
);

export default Recovery;
